import React, { useEffect, useState } from "react";
import request from "../../../../Helpers/API";

export const ResponsableSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);
  // const [responsablesCobranza, setResponsablesCobranza] = useState([]);

  // useEffect(() => {
  //   request
  //     .get("GenerarConvenioModal/DropDownListResponsables")
  //     .then((result) => {
  //       setResponsablesCobranza(result);
  //       const responsablesOptions = result.map((responsable) => ({
  //         linea: responsable.responsable_cobranza, 
  //         value: responsable.idusuario, 
  //       }));
  //       setState(responsablesOptions);
  //     })
  //     .catch((error) => {
  //       JSON.stringify("PERMISOS", "ERROR....", "error");
  //     });
  // }, []);

  return (
    <select
      className="select-responsable"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="CCCC">Consolidado</option>
      <option value="EJEC">Ejecutivo</option>
      <option value="COBS">Cobranza Sinaloa</option>
      <option value="COBN">Cobranza Nayarit</option>
      <option value="COBG">Gerencia</option>
      {state.map((item) => (
        <option key={`linea-${item.value}`} value={item.value}>
          {item.linea}
        </option>
      ))}
    </select>
  );
};